export default [
  {
    path: '/policy/list',
    name: 'policy-list',
    meta: {
      index: 5
    },
    component: () =>
      import(/* webpackChunkName: "news" */ '@/pages/policy-content/index.vue')
  },
  {
    path: '/policy/:id',
    name: 'policy-content',
    meta: {
      index: 5
    },
    component: () =>
      import(/* webpackChunkName: "news" */ '@/pages/policy-content/policy-content.vue')
  }
]
